import React from 'react'
import { Icon } from '@chakra-ui/icons'
import { FaCheckCircle } from 'react-icons/fa'
import { Box, Text, HStack } from '@chakra-ui/react'

interface Props {
    number?: number
    label: string
    isCompleted?: boolean
    isDisabled?: boolean
    alternateAction?: React.ReactNode
}

export default function StepHeader({
    number,
    label,
    isCompleted,
    isDisabled,
    alternateAction,
}: Props) {
    return (
        <Box w="full" position="relative">
            <HStack>
                <Text
                    fontWeight="semibold"
                    fontSize="lg"
                    opacity={isDisabled || isCompleted ? 0.5 : 1}
                    textDecoration={isCompleted ? 'line-through' : 'none'}
                >
                    {number && <Box as="span">{number}. </Box>}
                    {label}
                </Text>
                {isCompleted ? (
                    <Icon as={FaCheckCircle} color="brand.500" />
                ) : (
                    !isDisabled && alternateAction
                )}
            </HStack>
        </Box>
    )
}
